import { get, post, destroy } from "./base";

const InventoryUpdateServ = {
    // Get stock update logs
    getLogs: (params) => get("/inventory-updates", { params }),

    // Add a new stock update record
    addRecord: (payload) => post("/inventory-updates", payload),

    // Delete a record
    remove: (id) => destroy(`/inventory-updates/${id}`),
};

export default InventoryUpdateServ;
